/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Referral_DescriptionInputs */

const en_settings_referral_description = /** @type {(inputs: Settings_Referral_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your invite code and track referral rewards.`)
};

const es_settings_referral_description = /** @type {(inputs: Settings_Referral_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte tu código de invitación y sigue tus recompensas.`)
};

/**
* | output |
* | --- |
* | "Share your invite code and track referral rewards." |
*
* @param {Settings_Referral_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_referral_description = /** @type {((inputs?: Settings_Referral_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Referral_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_referral_description(inputs)
	return en_settings_referral_description(inputs)
});